/* eslint-disable */
const Vue = require('vue');
const Tabs = require('../../components/tabs');

// grab up all our data that gets attached to the window object on the route node template
const routeData = window.STOP_TIMES;
const tempStopData = window.TEMP_STOPS;
const allHeadsignData = window.HEADSIGN_ORDER;
const allServiceTimeData = window.SERVICE_TIME_ORDER;
const stopInfo = window.STOP_INFO;
const currentRoute = window.ROUTE_ID;

// the following routes are the preferred routes that all the approritate schedules should be sorted on
// keys match the route ids
// keys to 3rd level object should match the nice name of the calendar in lowercase
// keys to 4th level object should match the nicename of the headsign in lowercase
//trip_1n_mtwrf_0606
// const goldenTrips = {
//   route_1: {
//     'mon-sat': {
//       //'1n berwick via somersworth - sixth street': 'trip_1n_0630_20',
//       'northbound': 'trip_1n_0630_jan21', //1N Berwick via Somersworth - Sixth Street
//       'southbound': 'trip_1s_0555_jan21', //1S Dover via Sixth Street
//     }
//   },
//   route_6: {
//     'mon-fri': {
//       'northbound': 'trip_6n_0602_jan21', //6N Farmington'
//       'southbound': 'trip_6s_0531_jan21', //6S Rochester
//     },
//   },

//   route_12: {
//     'mon-sat': {
//       'northbound': 'trip_12n_0630_jan21', //12N Rochester via 108
//       'southbound': 'trip_12s_0656_jan21', //12S Dover via 108
//     }
//   },

//   route_13: {
//     'mon-sat': {
//       'northbound': 'trip_13n_0700_jan21', //13N Downtown Dover - Continues to Rochester via 108
//       'southbound': 'trip_13s_0530_jan21', //13S Downtown Portsmouth
//     }
//   },

//   route_14: {
//     'mon-sat': {
//       'northbound': 'trip_14n_0700_jan21', //14N Downtown Rochester via Exit 9 P&R
//       'southbound': 'trip_14s_0509_jan21', //14S Downtown Portsmouth via Exit 9 P&R
//     }
//   },

//   //INBOUND OUTBOUND TRIPS
//   route_33: {
//     'mon-fri': {
//       'inbound': 'trip_33i_0659_jan21', //33 Downtown Dover via Whittier - Shaws
//       'outbound': 'trip_33o_0630_jan21', //33 County Complex via Whittier - Shaws
//     },
//     'saturday': {
//       'inbound': 'trip_33i_s_0657_jan21', //33 Downtown Dover via Whittier - Shaws
//       'outbound': 'trip_33o_s_0630_jan21', //33 Portland Avenue via Whittier - Shaws
//     },
//   },

//   route_34: {
//     'mon-sat': {
//       'inbound': 'trip_34i_0517_jan21', //34 Downtown Dover
//       'outbound': 'trip_34o_0730_jan21', //34 Knox Marsh Road / 155 Outbound
//     },
//   },

//   route_40: {
//     'mon-sat': {
//       'inbound': 'trip_40i_0624_jan21', //40 Downtown Portsmouth via Borthwick - Islington
//       'outbound': 'trip_40o_0600_jan21', //40 Borthwick Trolley Outbound via Islington
//     }
//   },

//   route_41: {
//     'mon-sat': {
//       'inbound': 'trip_41i_0630_jan21', //41 Downtown Portsmouth
//       'outbound': 'trip_41o_0600_jan21', //41 Lafayette Trolley Outbound
//     }
//   },

//   route_42: {
//     'mon-fri': {
//       'inbound': 'trip_42i_0643_jan21', //42 Downtown Portsmouth via portsmouth Transportation Center
//       'outbound': 'trip_42o_0622_jan21', //42 Pease Shuttle Outbound via Portsmouth Transportation Center
//     }
//   },

//   // // route_43 will need TWO outbound options, or do we just pick one???
//   // // see email from Toby dated 20 April 2020.
//   route_43: {
//     'mon-sat': {
//       'inbound': 'trip_43i_0733_jan21', //43 Downtown Portsmouth via Woodbury
//       'outbound': 'trip_43o_0700_jan21', //43 Newington via Woodbury Outbound
//     }
//   },

//   route_44: {
//     'mon-fri': {
//       'inbound': 'trip_44i_0747_jan21', //44 Downtown Portsmouthd
//       'outbound': 'trip_44o_0736_jan21', //44 Kittery PNSY Gate 1 via City Hall Outbound
//     }
//   },

//   route_100_20: {
//     'mon-fri': {
//       'pm': 'trip_100p_1515_jan21', //100 Somersworth via 236
//       'am': 'trip_100a_0520_jan21', //100 PNSY Gate 1 via 236
//     },
//   },

// };

const goldenTrips = require('../../components/golden-route');
// console.log('goldenTrips');
// console.log(goldenTrips);

// rough overview
//
// Schedule
//   Tabs
//     Panel -- multiple
//       City -- multiple
//         Row -- multiple
//           Single Stop Info

// console.log(routeData);
// console.log(currentRoute);
const app = new Vue({
  render() {
    return <Tabs routeData={routeData}
      tempStopData={tempStopData}
      allHeadsignData={allHeadsignData}
      allServiceTimeData={allServiceTimeData}
      stopInfo={stopInfo}
      goldenTrips={goldenTrips[currentRoute]}
    />;
  },
});

if (document.getElementById('app-root')) {
  app.$mount('#app-root');
}


// attach listener to remove hover state
$('.hover-pop-up__icon').on('touchstart click', e => {
  attachHandler();
});

// js gives no way remove :hover from element, so we copy the element,
// append it after itself and remove the original
function attachHandler() {
  $(document).on('touchend.temp', e => {
    if (!$(e.target).closest('.hover-pop-up').length) {
      const element = $('.hover-pop-up:hover');
      element.insertAfter(element);
      element.remove;
      $(document).off('.temp');
    }
  });
}

// maps on each route details page
$(window).on('load', function() {
  if($('#route-map').length) {
    initRouteMap()
  }
});
function initRouteMap() {
  console.log('initRouteMap')
  console.log( `${window.location.origin}${window.KML_FILE}`)
  const INTIAL_CENTER = {lat: 43.1975565, lng: -70.8776229};
  var map = new google.maps.Map(document.getElementById('route-map'), {
    zoom: 11,
    center: INTIAL_CENTER,
    zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
    },
    streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
    },
  });

  // url must be full URL to file, and cannot be htaccess protected
  // drupal does not give easy way to get URL to file, so we prepend the location orginin (base url)
  //console.log('adding map layer');
  var ctaLayer = new google.maps.KmlLayer({
    url: `${window.location.origin}${window.KML_FILE}`,
    map: map
  });
}


// new 2020 interactive maps on Schedules landing page (and tabs)
$(window).on('load', function() {
  if($('#coast-system-map').length) {
    initSystemRouteMap()
  }
});
function initSystemRouteMap() {
  console.log('initSystemRouteMap')
  console.log(`${window.location.origin}/sites/default/files/shape-data/COAST_System_2024.kml`)
  const INTIAL_CENTER = {lat: 43.1975565, lng: -70.8776229};
  var map = new google.maps.Map(document.getElementById('coast-system-map'), {
    zoom: 10,
    center: INTIAL_CENTER,
    zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
    },
    streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
    },
  });

  // url must be full URL to file, and cannot be htaccess protected
  // drupal does not give easy way to get URL to file, so we prepend the location orginin (base url)
  // console.log('adding system map layer, zoom level 4');

  var ctaLayer = new google.maps.KmlLayer({
    url: `${window.location.origin}/sites/default/files/shape-data/COAST_System_2024.kml`,
    preserveViewport: true,
    map: map
  });
}
